import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
@Injectable({
  providedIn: 'root'
})
export class RazaService {
  private apiUrl =  `${environment.apiUrl}/api/raza`; 
 // private apiUrl = 'http://localhost:3000/api/raza'; // URL de la API para razas

  constructor(private http: HttpClient) { }

  getRazas(): Observable<any[]> {
    return this.http.get<any[]>(this.apiUrl).pipe(
      catchError(error => {
        console.error('Error al obtener registros de razas:', error);
        return throwError(() => new Error('Error al obtener razas'));
      })
    );
  }
}
